export const isImageFile = (file) => {
  return Boolean(file && typeof file.type === 'string' && file.type.startsWith('image/'));
};

const loadImageFromBlob = (blob) => {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(blob);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve(img);
    };
    img.onerror = (e) => {
      URL.revokeObjectURL(url);
      reject(e);
    };
    img.src = url;
  });
};

const canvasToBlob = (canvas, type, quality) => {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), type, quality);
  });
};

export const resizeImageToWidth = async (
  file,
  {
    width = 100,
    mimeType = 'image/jpeg',
    quality = 0.82,
    fileName = 'thumb.jpg',
  } = {}
) => {
  if (!isImageFile(file)) {
    throw new Error('이미지 파일만 업로드할 수 있습니다.');
  }

  const targetWidth = Math.max(1, Math.round(Number(width) || 100));
  const img = await loadImageFromBlob(file);
  const ratio = img.width > 0 ? targetWidth / img.width : 1;
  const targetHeight = Math.max(1, Math.round(img.height * ratio));

  const canvas = document.createElement('canvas');
  canvas.width = targetWidth;
  canvas.height = targetHeight;

  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

  const blob = await canvasToBlob(canvas, mimeType, quality);
  if (!blob) {
    throw new Error('썸네일 생성에 실패했습니다.');
  }

  return new File([blob], fileName, { type: mimeType });
};

export const compressImageToMaxBytes = async (
  file,
  {
    maxBytes = 1024 * 1024,
    maxDimension = 1024,
    mimeType = 'image/jpeg'
  } = {}
) => {
  if (!isImageFile(file)) {
    throw new Error('이미지 파일만 업로드할 수 있습니다.');
  }

  if (file.size <= maxBytes) {
    return file;
  }

  const img = await loadImageFromBlob(file);

  const ratio = Math.min(1, maxDimension / Math.max(img.width, img.height));
  const targetWidth = Math.max(1, Math.round(img.width * ratio));
  const targetHeight = Math.max(1, Math.round(img.height * ratio));

  const canvas = document.createElement('canvas');
  canvas.width = targetWidth;
  canvas.height = targetHeight;

  const ctx = canvas.getContext('2d');
  ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

  let quality = 0.9;
  let blob = await canvasToBlob(canvas, mimeType, quality);

  while (blob && blob.size > maxBytes && quality > 0.2) {
    quality -= 0.1;
    blob = await canvasToBlob(canvas, mimeType, quality);
  }

  if (!blob) {
    throw new Error('이미지 압축에 실패했습니다.');
  }

  if (blob.size > maxBytes) {
    throw new Error('이미지 용량을 1MB 이하로 줄이지 못했습니다. 다른 이미지를 사용해주세요.');
  }

  return new File([blob], file.name, { type: mimeType });
};
